import { GET_ISSUERS, GET_PERSISTED_ISSUERS } from "../types/issuerType";

const initialState = {
    issuers: [],
    persistedIssuers: []
};

const issuerReducer = (state = initialState, action) => {
    const { payload, type } = action;
    switch (type) {
        case GET_ISSUERS:
            return {
                ...state,
                issuers: payload
            };
        case GET_PERSISTED_ISSUERS:
            return {
                ...state,
                persistedIssuers: payload
            };
        default:
            return state;
    }
};

export default issuerReducer;
